export default __webpack_public_path__ + "static/money-ad80ae80af70a5b6f508ee0bbaaf5a2e.svg";